<template>
  <div>
    <Head :title="__(title)" />

    <div class="flex flex-col md:flex-row gap-3 mb-4 justify-between items-center ticket-filters">
      <search-input v-model="form.search" class="w-full max-w-md search" @reset="reset"></search-input>
      <div class="filter-add-new flex flex-col gap-3 md:flex-row items-center">
        <!-- <a v-if="user_access.asset.export" class="uppercase gap-[1px] text-sm px-3 py-2 flex items-center justify-center" href="/dashboard/asset_management/assets/export/excel">
          <img class="w-6 h-6" src="/images/svg/export-csv.svg" alt="Export CSV" />
          <span>{{ __('Export') }}</span>
        </a> -->
        <label v-if="user_access.asset_serial_number.create" for="importCSV" class="uppercase gap-[1px] text-sm px-3 py-2 flex items-center justify-center">
          <img class="w-6 h-6" src="/images/svg/import-csv.svg" alt="Import CSV" />
          <span>{{ __('Import') }}</span>
          <input @change="uploadImportCSV" class="hidden" id="importCSV" type="file" />
        </label>
        <button v-if="user_access.asset_serial_number.create" class="gap-[1px] text-sm px-3 py-2 flex items-center justify-center" @click="downloadTemplateExcel">
          <img class="w-6 h-6" src="/images/svg/export-csv.svg" alt="Export CSV" />
          <span>{{ __('Download Template') }}</span>
        </button>
        <Link v-if="user_access.asset.create" class="btn-indigo" :href="this.route('asset_serial_number.create')">
          <span>{{ __('Create a New Serial Number') }}</span>
        </Link>
      </div>
    </div>

    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">#{{ __('ID') }}</th>
          <th class="px-6 pt-6 pb-4">{{ __('Serial Number') }}</th>
          <th class="px-6 pt-6 pb-4">{{ __('Type') }}</th>
          <th class="px-6 pt-6 pb-4">{{ __('Brand') }}</th>
          <th class="px-6 pt-6 pb-4">{{ __('Category') }}</th>
        </tr>
        <tr v-for="item in serial_numbers.data" :key="item.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="this.route('asset_serial_number.edit', item.id)">
              {{ item.id }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="this.route('asset_serial_number.edit', item.id)">
              {{ item.sn }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="this.route('asset_serial_number.edit', item.id)">
              {{ item.type }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="this.route('asset_serial_number.edit', item.id)">
              {{ item.brand }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="this.route('asset_serial_number.edit', item.id)">
              {{ item.category }}
            </Link>
          </td>
          <td class="border-t w-px">
            <Link class="px-4 flex items-center" :href="this.route('asset_serial_number.edit', item.id)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
        </tr>
        <tr v-if="serial_numbers.data.length === 0">
          <td class="border-t px-6 py-4" colspan="8">No data found.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="serial_numbers.links" />
  </div>
</template>

      <script>
import { Link, Head } from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchInput from '@/Shared/SearchInput'

export default {
  metaInfo: { title: 'Category Asset' },
  components: {
    Icon,
    Link,
    Head,
    Pagination,
    SearchInput,
  },
  layout: Layout,
  props: {
    title: String,
    filters: Object,
    serial_numbers: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
      },
      user_access: this.$page.props.auth.user.access,
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get(this.route('asset_serial_number'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    uploadImportCSV(e) {
      if (e.target.files.length) {
        this.$inertia.form({ file: e.target.files[0] }).post(this.route('asset_serial_number.import'))
      }
    },
    downloadTemplateExcel() {
      const link = document.createElement('a')
      link.href = '/template_excel/serial_number_template_import.xlsx' // Path to the template file
      link.download = 'serial_number_template_import.xlsx' // Name the file as you want
      link.click()
    },
  },
}
</script>
